"use strict";

import Vue from 'vue'

const EventBus = new Vue()

export default EventBus;



// WEBPACK FOOTER //
// ./resources/mhg/vue/events/event-bus.js